module.exports = __webpack_public_path__ + "img/thumb_24.60e79ddb.jpg";